<div
	*ngIf="isLoading"
	style="margin-top: 60px; padding: 50px 20px; text-align: center"
>
	<freud-loader size="sm" [bgColor]="false"></freud-loader>
</div>

<div *ngIf="!isLoading">
	<div class="row totalAv">
		{{ 'GENERAL.AVAILABILITIES' | translate }} (<span
			style="font-weight: 700"
			>{{ totalShow }}</span
		>)
	</div>

	<div
		*ngFor="let availability of availabilitiesShow; let i = index"
		class="row user-card shadow avList"
	>
		<div class="avListSlots">
			<div class="avPeriod">
				<div class="row">
					<div class="avLabel">
						{{ 'GENERAL.FROM' | translate | uppercase }}
					</div>
					<div class="avDate">
						{{ availability | infullDate: 'startDate' | uppercase }}
					</div>
				</div>
				<div class="row">
					<div class="avLabel">{{ 'GENERAL.TO' | translate | uppercase }}</div>
					<div class="avDate">
						{{ availability | infullDate: 'endDate' | uppercase }}
					</div>
				</div>
			</div>

			<div class="avTimeSlots">
				<table class="table">
					<tr *ngFor="let ts of availability.periods">
						<td>{{ daysOfWeek[ts.dayOfWeek] | uppercase }}</td>
						<td class="tdTime">
							{{ ts.startTime | shortTime }} - {{ ts.endTime | shortTime }}
						</td>
					</tr>
				</table>
			</div>

			<div class="avListButtons">
				<img
					(click)="editItem(availability)"
					class="mnuIcon btnEdit"
					src="/assets/images/icons/edit.svg"
				/>
				<img
					(click)="removeItem(availability)"
					class="mnuIcon btnRemove"
					src="/assets/images/icons/delete.svg"
				/>
			</div>
		</div>
	</div>
</div>
